import { render } from "./OlapFilterTable.vue?vue&type=template&id=6a377168&scoped=true&ts=true"
import script from "./OlapFilterTable.vue?vue&type=script&lang=ts"
export * from "./OlapFilterTable.vue?vue&type=script&lang=ts"

import "./OlapFilterTable.vue?vue&type=style&index=0&id=6a377168&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a377168"]])

export default __exports__